import { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, useHistory } from 'react-router-dom';
import { ref as AppRef, child, set,  get } from "firebase/database";
import { getAuth } from "firebase/auth";
import './App.css';
import FloatingLoading from './Components/PopUpModal/ModalVersions/FloatingLoading/FloatingLoading';
import CookiesInfo from './Components/CookiesInfo/CookiesInfo';
import dataBase from './config';
import Politics from './Components/Politics/Politics';
import LoginBar from './Components/Header/LoginBar/LoginBar';
import NewsShortCut from './Components/NewsShortCut/NewsShortCut';
import LessonsInfo from './Components/LessonsInfo/LessonsInfo';
import MissionDescription from './Components/MissionDescription/MissionDescription';
import CookiesPage from './Components/CookiesPage/CookiesPage';
import LoginPage from './Components/LoginPage/LoginPage';
import OfferDetails from './Components/OfferDetails/OfferDetails';
import UserPanel from './Components/UserPanel/UserPanel';
import AddOffer from './Components/AddOffer/AddOffer';
import Footer from './Components/Footer/Footer';
import UserSyncWithFireBase from './Components/UserSyncWithFireBase/UserSyncWithFireBase';
import PopUpModal from './Components/PopUpModal/PopUpModal';
import Contact from './Components/Contact/Contact';
import ShowEditFields from './Components/AddOffer/EditFields/ShowEditFields';
import ChooseOfferToEdit from './Components/AddOffer/ChooseOfferToEdit/ChooseOfferToEdit';
// Funkcja zwracająca pofiltrowane oferty:
import useFilterOffersToDisplay from './customHooks/useFilterOffersToDisplay/useFilterOffersToDisplay';
import ShowOnlineStatus from './Components/ShowOnLineStatus/ShowOnlineStatus';
import ReactGA from 'react-ga4';
import { useAtom } from 'jotai';
import LandingPage from './Components/LandingPage/LandingPage';

import { useDetailedOffer, useSelectedTitle, useSelectedDescription, useFilteredCity, useFilteredDistrict, useFilteredStreet, useFilteredMarket, useFilteredMinSquare, useFilteredMaxSquare, useSelectedDistrict, useFilteredMaxPrice, useFilteredMinPrice, useSelectedBussinesAdditions, useSelectedBussinesMedia, useSelectedLandMedia, useSelectedRoadType, useSelectedMeasuresWidth, useSelectedMeasuresHeight, useSelectedFloorsNumberInBuilding, useSelectedBasementInfo, useSelectedBalconyNumber, useSelectedParkingSpot, useSelectedHeatingType, useSelectedFloorNumber, useSelectedRoomsNumber, useSelectedElevatorStatus, useSelectedBuildStatus, useSelectedBuildYear, useSelectedSquareFootage, useMainFilter, useLoggedUser, useSecondFilter, useDownloadedOffers, useOffersToDisplay, useSearchInputValue,
         useCountryFilter, useRefreshUserInfo, useCityFilter, usePriceFilter, useShowPopUpModal, useModalVersion, useModalInfo,
         useAllCompanies, useExpiredOffers, useExperienceFilter, useCurrencyFilter, useApplyWithSJProfile, useExternalApplyUrl, useSelectedSpeciality, useSelectedMarket, useSelectedPrice, useSelectedCity, useSelectedStreet, useSelectedBuilding, useSelectedLocal, useSelectedAdressLat, useSelectedAdressLng, useSelectedMainCategory, useSelectedImages, 
         useAwaitOffer, useDisplayCookiesInfo } from './data/GlobalStates';
import Partners from './Components/Partners/Partners';
import SocialMedia from './Components/SocialMedia/SocialMedia';
import AllNewsDisplayer from './Components/AllNewsDisplayer/AllNewsDisplayer';
import CoachInfo from './Components/CoachInfo/CoachInfo';

const App = () => {

const [ refresh, setRefresh] = useState(99)
const [ countriesChoose, setCountriesChoose] = useState(false)
const [ countryFilterCode, setCountryFilterCode] = useState('')
const [ AddOrderPictureUrl, setAddOrderPictureUrl ] = useState('')
const [ AddOrderPictureFile, setAddOrderPictureFile ] = useState('')

const [ Country, setCountry ] = useState('Wybierz')
const [ MaxSalaryWarn, setMaxSalaryWarn ] = useState(false)
const [ checkUser, setCheckUser ] = useState(1)
const [ UserLogo, setUserLogo] = useState('')
const [ popularCountries, setPopularCountries ] = useState(0)
const [ popularCities, setPopularCities ] = useState(0)
const [ isOnline, setIsOnline] = useState(navigator.onLine)

  //stany globalne:
  const [ MainFilter, setMainFilter ] = useAtom(useMainFilter);
  const [ SecondFilter, setSecondFilter ] = useAtom(useSecondFilter);
  const [ ExperienceFilter, setExperienceFilter ] = useAtom(useExperienceFilter);
  const [ CurrencyFilter, setCurrencyFilter ] = useAtom(useCurrencyFilter);
  const [ LoggedUser, setLoggedUser ] = useAtom(useLoggedUser);
  const [ DownloadedOffers, setDownloadedOffers ] = useAtom(useDownloadedOffers);
  const [ OffersToDisplay, setOffersToDisplay ] = useAtom(useOffersToDisplay);
  const [ SearchInputValue, setSearchInputValue ] = useAtom(useSearchInputValue);
  const [ CountryFilter, setCountryFilter] = useAtom(useCountryFilter);
  const [ RefreshUserInfo, setRefreshUserInfo] = useAtom(useRefreshUserInfo);
  const [ CityFilter, setCityFilter] = useAtom(useCityFilter);
  const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
  const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
  const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
  const [ AllCompanies, setAllCompanies] = useAtom(useAllCompanies);
  const [ ExpiredOffers, setExpiredOffers] = useAtom(useExpiredOffers);
  const [ ApplyWithSJProfile, setApplyWithSJProfile] = useAtom(useApplyWithSJProfile);
  const [ ExternalApplyUrl, setExternalApplyUrl] = useAtom(useExternalApplyUrl);
  const [ SelectedSpeciality, setSelectedSpeciality] = useAtom(useSelectedSpeciality);
  const [ SelectedMarket, setSelectedMarket ] = useAtom(useSelectedMarket);
  const [ SelectedPrice, setSelectedPrice ] = useAtom(useSelectedPrice);
  const [ SelectedCity, setSelectedCity ] = useAtom(useSelectedCity);
  const [ SelectedStreet, setSelectedStreet ] = useAtom(useSelectedStreet);
  const [ SelectedBuilding, setSelectedBuilding ] = useAtom(useSelectedBuilding);
  const [ SelectedLocal, setSelectedLocal ] = useAtom(useSelectedLocal);
  const [ SelectedAdressLat, setSelectedAdressLat ] = useAtom(useSelectedAdressLat);
  const [ SelectedAdressLng, setSelectedAdressLng ] = useAtom(useSelectedAdressLng);
  const [ SelectedMainCategory, setSelectedMainCategory ] = useAtom(useSelectedMainCategory);
  const [ SelectedImages, setSelectedImages ] = useAtom(useSelectedImages);
  const [ AwaitOffer, setAwaitOffer ] = useAtom(useAwaitOffer);
  const [ SelectedSquareFootage, setSelectedSquareFootage ] = useAtom(useSelectedSquareFootage);
  const [ SelectedBuildYear, setSelectedBuildYear ] = useAtom(useSelectedBuildYear);
  const [ SelectedBuildStatus, setSelectedBuildStatus ] = useAtom(useSelectedBuildStatus);
  const [ SelectedElevatorStatus, setSelectedElevatorStatus ] = useAtom(useSelectedElevatorStatus);
  const [ SelectedRoomsNumber, setSelectedRoomsNumber ] = useAtom(useSelectedRoomsNumber);
  const [ SelectedFloorNumber, setSelectedFloorNumber ] = useAtom(useSelectedFloorNumber);
  const [ SelectedHeatingType, setSelectedHeatingType ] = useAtom(useSelectedHeatingType);
  const [ SelectedParkingSpot, setSelectedParkingSpot ] = useAtom(useSelectedParkingSpot);
  const [ SelectedBalconyNumber, setSelectedBalconyNumber ] = useAtom(useSelectedBalconyNumber);
  const [ SelectedBasementInfo, setSelectedBasementInfo ] = useAtom(useSelectedBasementInfo);
  const [ SelectedFloorsNumberInBuilding, setSelectedFloorsNumberInBuilding ] = useAtom(useSelectedFloorsNumberInBuilding);
  const [ SelectedMeasuresHeight, setSelectedMeasuresHeight ] = useAtom(useSelectedMeasuresHeight);
  const [ SelectedMeasuresWidth, setSelectedMeasuresWidth ] = useAtom(useSelectedMeasuresWidth);
  const [ SelectedRoadType, setSelectedRoadType ] = useAtom(useSelectedRoadType);
  const [ SelectedLandMedia, setSelectedLandMedia ] = useAtom(useSelectedLandMedia);
  const [ SelectedBussinesMedia, setSelectedBussinesMedia ] = useAtom(useSelectedBussinesMedia);
  const [ SelectedBussinesAdditions, setSelectedBussinesAdditions ] = useAtom(useSelectedBussinesAdditions);
  const [ PriceFilter, setPriceFilter ] = useAtom(usePriceFilter);
  const [ FilteredMinPrice, setFilteredMinPrice ] = useAtom(useFilteredMinPrice);
  const [ FilteredMaxPrice, setFilteredMaxPrice ] = useAtom(useFilteredMaxPrice);
  const [ SelectedDistrict, setSelectedDistrict ] = useAtom(useSelectedDistrict);
  const [ FilteredMinSquare, setFilteredMinSquare ] = useAtom(useFilteredMinSquare);
  const [ FilteredMaxSquare, setFilteredMaxSquare ] = useAtom(useFilteredMaxSquare);
  const [ FilteredMarket, setFilteredMarket ] = useAtom(useFilteredMarket);
  const [ FilteredCity, setFilteredCity ] = useAtom(useFilteredCity);
  const [ FilteredDistrict, setFilteredDistrict ] = useAtom(useFilteredDistrict);
  const [ FilteredStreet, setFilteredStreet ] = useAtom(useFilteredStreet);
  const [ SelectedDescription, setSelectedDescription ] = useAtom(useSelectedDescription);
  const [ SelectedTitle, setSelectedTitle ] = useAtom(useSelectedTitle);
  const [ DisplayCookiesInfo, setDisplayCookiesInfo ] = useAtom(useDisplayCookiesInfo);
  const [ DetailedOffer, setDetailedOffer ] = useAtom(useDetailedOffer);

  

  const date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDay();  

  const authedUser = getAuth(); 
  const history = useHistory();
  const filteredOffers = useFilterOffersToDisplay(DownloadedOffers, MainFilter, SecondFilter, PriceFilter, FilteredMinPrice, FilteredMaxPrice, FilteredMinSquare, FilteredMaxSquare, FilteredMarket, FilteredCity, FilteredDistrict, FilteredStreet, CountryFilter, ExperienceFilter, SearchInputValue, CityFilter, CurrencyFilter)
  const db = dataBase; // zapis
  const dbRef = AppRef(dataBase); //odczyt
  const trackingID = process.env.REACT_APP_MEASURMENTID;
  ReactGA.initialize(trackingID);
 

useEffect(() => { //pobranie i aktualizacja newsów

  const UpdateDownloadedOffers = async () => { // update downloadedOffers wywoływany zmianą któregoś z filtrów
    try {
       await get(child(dbRef, `offers`)).then((offers) => {
           setExpiredOffers(Object.values(offers.val()).filter(offer => offer.companyName === LoggedUser.name && offer.visibility === false))
           setDownloadedOffers(Object.values(offers.val()))
           setRefreshUserInfo(RefreshUserInfo + 1)
     })
    }
    catch (error) {
      console.log(error, 'offers not downloaded')
       setRefresh(refresh + 1) // trigger dla ponownej próby pobania danych 
        set(AppRef(db, `errors/${year}/${month}/${day}/UpdateDownloadedOffers`), error.message)
    }
  };
  if (!DownloadedOffers.length) {
    UpdateDownloadedOffers()
  }
}, [refresh])


useEffect(() => {
  UserSyncWithFireBase(authedUser, setModalInfo, setModalVersion, setShowPopUpModal, setLoggedUser)
}, [RefreshUserInfo, authedUser.currentUser])


useEffect(() => { // Uzupełnienie stanów do edycji ogłoszenia/ stany pochodzą z właściwości oferty
if ( AwaitOffer && ( window.location.pathname === '/EdycjaOgloszenia' || window.location.pathname === '/userPanel')) {
  setSelectedTitle(AwaitOffer.title)
  setSelectedMainCategory(AwaitOffer.MainCategory)//
  setSelectedSpeciality(AwaitOffer.SubCategory)//
  setSelectedMarket(AwaitOffer.market)//
  setSelectedDescription(AwaitOffer.description)//
  setSelectedCity(AwaitOffer.city)//
  setSelectedDistrict(AwaitOffer.district || null) 
  setSelectedStreet(AwaitOffer.street || null)//
  setSelectedBuilding(AwaitOffer.building  || null )//
  setSelectedLocal(AwaitOffer.local  || null )//
  setSelectedAdressLat(AwaitOffer.cityLatit || null )//
  setSelectedAdressLng(AwaitOffer.cityLong || null )//
  setSelectedPrice(AwaitOffer.price || '' )//
  setSelectedSquareFootage(AwaitOffer.squareFootage || '' )
  setSelectedImages(AwaitOffer.ImagesUrls || [] ) //
  setSelectedBuildYear(AwaitOffer.buildYear || null )//
  setSelectedBuildStatus(AwaitOffer.buildStatus || null )//
  setSelectedElevatorStatus(AwaitOffer.elevatorStatus || null)//
  setSelectedRoomsNumber(AwaitOffer.roomsNumber || null)//
  setSelectedFloorNumber(AwaitOffer.floor || null)
  setSelectedHeatingType(AwaitOffer.heatingType || null)
  setSelectedParkingSpot(AwaitOffer.parkingSpot || null)
  setSelectedBalconyNumber(AwaitOffer.balconyNumber || null)
  setSelectedBasementInfo(AwaitOffer.basement || null)
  setSelectedFloorsNumberInBuilding(AwaitOffer.totalFloors || null)
  setSelectedMeasuresHeight(AwaitOffer.landHeight || null)
  setSelectedMeasuresWidth(AwaitOffer.landWidth || null)
  setSelectedRoadType(AwaitOffer.roadType || null)//
  setSelectedLandMedia(AwaitOffer.landMedia || [])//
  setSelectedBussinesAdditions(AwaitOffer.bussinesAdditions || [])//
  setSelectedBussinesMedia(AwaitOffer.bussinesMedia || [])//
} else return

}, [AwaitOffer])


useEffect(() => { //odświeżenie ofert podczas filtrowania ofert wg.Kategorii etc

  if (DownloadedOffers.length) {
      setOffersToDisplay(filteredOffers)
  }

}, [MainFilter, SecondFilter, CountryFilter, PriceFilter, FilteredMinPrice, FilteredMaxPrice, FilteredMinSquare, FilteredMaxSquare, FilteredMarket, FilteredCity,FilteredDistrict, FilteredStreet, ExperienceFilter, CurrencyFilter, SearchInputValue, CityFilter, DownloadedOffers.length]);

useEffect(() => {
  const handleStatusChange = () => {
    setIsOnline(navigator.onLine);
  };
  window.addEventListener('online', handleStatusChange);
  window.addEventListener('offline', handleStatusChange);
  return () => {
    window.removeEventListener('online', handleStatusChange);
    window.removeEventListener('offline', handleStatusChange);
  };
}, [isOnline]);


return (
<div id='App'>
{ isOnline ? '' : <ShowOnlineStatus/>}
<Router history={history}>

<Route exact path='/'>

  <Helmet>
          <title>Polska Akademia Tyczki</title>
          <meta name="robots" content="index, follow" />
          <meta name='Keywords' content='LekkoAtletyka, Sport, Tyczka, Pole Vault'/>
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl'/>
   </Helmet>

      { DisplayCookiesInfo ? <CookiesInfo/> : null }
      { !OffersToDisplay ? <FloatingLoading/> :  
      
      <>
         <LoginBar/>
          <LandingPage/>
           <NewsShortCut/>
            <LessonsInfo/>
             <Partners/>
              <SocialMedia/>
               <Footer/>
         </>
        }
</Route>


<Route exact path='/login'>
    <Helmet>
          <title>Polska Akademia Tyczki</title>
          <meta name="robots" content="index, nofollow" />
          <meta name='Keywords' content='Skok o Tyczce'/>
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl'/>
   </Helmet>
          <LoginPage authedUser={authedUser}/>
</Route>


<Route path='/Oferty/:id/:title'>
                   <Helmet>
                         <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
                         <meta name="robots" content="index, follow" />
                         <title>{DetailedOffer ?  DetailedOffer.title.slice(0,60).toString() : null}</title>
                         <meta name="description" content="Skok o Tyczce" />
                         <meta property="og:url" content='https://polskaakademiatyczki.pl'/>
                    </Helmet>
          <OfferDetails
            setRefresh={setRefresh}
            />
</Route>


<Route exact path='/userPanel'>
<Helmet>
          <title>Polska Akademia Tyczki</title>
          <meta name="robots" content="index, nofollow" />
</Helmet>
        <LoginBar/>
            <UserPanel
              UserLogo={UserLogo}
              setUserLogo={setUserLogo}
              refresh={refresh}
              setRefresh={setRefresh}
              setSelectedSpeciality={setSelectedSpeciality}
              setCountry={setCountry}
              setCountryFilterCode={setCountryFilterCode}
            />
          <Footer/>
</Route>




<Route exact path='/aktualnosci'> 
   <Helmet>
          <title>Polska Akademia Tyczki - Aktualnosci</title>
          <meta name="robots" content="index, follow" />
          <meta name='Keywords' content='Skok o Tyczce'/>
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl/aktualnosci'/>
   </Helmet>

          <LoginBar/>
            <AllNewsDisplayer/>
              <Footer/>
</Route>




<Route exact path='/misja'> 
   <Helmet>
          <title>Polska Akademia Tyczki - Aktualnosci</title>
          <meta name="robots" content="index, follow" />
          <meta name='Keywords' content='Skok o Tyczce'/>
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl/aktualnosci'/>
   </Helmet>

          <LoginBar/>
            <MissionDescription/>
              <Footer/>
</Route>



<Route exact path='/trenerzy'> 
   <Helmet>
          <title>Polska Akademia Tyczki - Trenerzy</title>
          <meta name="robots" content="index, follow" />
          <meta name='Keywords' content='Skok o Tyczce'/>
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl/trenerzy'/>
   </Helmet>

          <LoginBar/>
           <CoachInfo/>
            <Footer/>
</Route>



<Route exact path='/Kontakt'>

  <Helmet>
          <title>PolskaAkademiaTyczki.pl - Kontakt</title>
          <meta name="robots" content="index, nofollow" />
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
          <meta property="og:url" content='https://polskaakademiatyczki.pl'/>
   </Helmet>

    <LoginBar/>
       <Contact/>
        <Footer/>
       
</Route>




<Route exact path='/DodajNews'>
  <Helmet>
          <title>Polska Akademia Tyczki</title>
          <meta name="robots" content="index, nofollow" />

  </Helmet>
        <LoginBar/>
          <AddOffer
            setRefresh={setRefresh}
            refresh={refresh}
            checkUser={checkUser}
            setCheckUser={setCheckUser}
            setCountry={setCountry}
            MaxSalaryWarn={MaxSalaryWarn}
            Country={Country}
            countryFilterCode={countryFilterCode}
            setCountryFilterCode={setCountryFilterCode}
        />
</Route>


<Route exact path='/Cookies'>
  <Helmet>
          <title>PolskaAkademiaTyczki.pl - Cookies</title>
          <meta name="robots" content="index, nofollow" />
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
   </Helmet>
        <CookiesPage />
</Route>


<Route exact path='/Polityka'>
  <Helmet>
          <title>PolskaAkademiaTyczki.pl - Polityka</title>
          <meta name="robots" content="index, nofollow" />
          <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/polskaakademiatyczki.firebasestorage.app/o/PageURLBackground%2F1.png?alt=media&token=2a77b53e-156c-40bb-9f0d-e51aa31df3e2"/>
   </Helmet>
        <Politics />
</Route>




<Route exact path='/EdycjaOgloszenia'>
  <Helmet>
          <meta name="robots" content="index, nofollow" />
   </Helmet>
        {AwaitOffer ?
          <>
           <LoginBar/>
           <ShowEditFields
               refresh={refresh}
               setRefresh={setRefresh}
                 />
        </>
        : <ChooseOfferToEdit />}
</Route>

  { ShowPopUpModal ?
              <PopUpModal
                UserLogo={UserLogo}
                setUserLogo={setUserLogo}
                authedUser={authedUser}
                refresh={refresh}
                setRefresh={setRefresh}
                setCountryFilter={setCountryFilter}
                setAddOrderPictureUrl={setAddOrderPictureUrl}
                AddOrderPictureFile={AddOrderPictureFile}
                setAddOrderPictureFile={setAddOrderPictureFile}
                setSelectedSpeciality={setSelectedSpeciality}
                setCountry={setCountry}
                countryFilterCode={countryFilterCode}
                setCountryFilterCode={setCountryFilterCode}
                popularCountries={popularCountries}
                popularCities={popularCities}
                AddOrderPictureUrl={AddOrderPictureUrl}
              /> : ''
  }


     </Router>
  </div>
  );
}

export default App;
